<template>
    <div>
        <v-main>
            <span class="background-image"></span>    
            <span class="background-filter"></span>                
            <v-row dense>
                <v-col xs="12" sm="12" md="12" lg="4" xl="4">                        
                    <panel_left ref="leftpanel"/>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="8" xl="8">                        
                    <panel_right ref="rightpanel"/>
                </v-col>                
            </v-row>      
            <navBar title="Ares - Main menu" :home="true" :accolist="true" type="main"/>
        </v-main>
    </div>
</template>

<script>
    
    import navBar from "@/components/ui/navbars/navbar.vue";
    import panel_left from "@/components/dashboard/panel_left.vue"
    import panel_right from "@/components/dashboard/panel_right.vue"

    export default {        
        computed:{
        },        
        components: {
            navBar,
            panel_left,
            panel_right,
        },
        destroyed() {
            console.log('destroyed');
            this.stopTimer();
        },              
        mounted() {
            this.startTimer(); // start timer
        },              
        data() {
            return {      
                letTimer: null,
            }
        },    
        methods: {
            startTimer(){
                const self = this;
                this.letTimer = setInterval(function () {
                    console.log('interval = 1 min --> reload panel data');
                    try{
                        self.$refs.leftpanel.load();
                        self.$refs.rightpanel.load();
                    } catch(err) {
                        console.log('no reload');
                    }
                }, 60000);                
            },
            stopTimer(){
                clearInterval(this.letTimer);
            }
        },           
    }
</script>

<style scoped>
  .background-image {
    width: 100%;
    height: 100%;
    position: fixed; /* absolute */
    top: 0;
    left: 0;
    background: url('../../../assets/dashboard/w_background.png') no-repeat right bottom;
    background-size: cover;
    background-color: white;
    transform: scale(1.1);
  }  
  .background-filter{
    background: rgba(255,255,255,0.7);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

</style>
